export default function EmptyState({ title, description, testId }) {
  return (
    <div className="py-12 text-center" data-testid={testId}>
      <div className="text-sm font-semibold text-slate-700">{title}</div>
      {description && <div className="text-xs text-slate-500 mt-1">{description}</div>}
    </div>
  );
}
